import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。
const unpaidOperationCheckServices = (memberId: string): any => {
  const config = {
    params: { member_id: memberId },
  };
  return {
    getUnpaidOperationCheck: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/unpaid/operation/check`, config),
  };
};

export default unpaidOperationCheckServices;
